export default "__VITE_ASSET__c96e24b2__"